import { useState, useEffect } from 'react';

import { Tab, Tabs } from '@mui/material';
import { periods } from 'src/utils/rollup';

// Tabs to select the rollup period for the finance context
export default function RollUpTabs({ value = 'month', onChange, sx }) {
  const [currentTab, setCurrentTab] = useState(value);

  const handleChange = (event, newValue) => setCurrentTab(newValue);

  useEffect(() => onChange(currentTab), [currentTab]);
  useEffect(() => setCurrentTab(value), [value]);

  return (
    <Tabs value={value} onChange={handleChange} aria-label="Rollup Period" sx={{ ...sx }}>
      {periods.map((period) => (
        <Tab {...period} key={period.value} />
      ))}
    </Tabs>
  );
}
